import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage.jsx';
import SignupPage from './pages/SignupPage.jsx';
import VerifyOtpPage from './pages/VerifyOtpPage.jsx';
import OnboardingPage from './pages/OnboardingPage.jsx';
import LogoutPage from './pages/LogoutPage.jsx';
import ForgotPasswordPage from './pages/ForgotPasswordPage.jsx';
import ResetPasswordPage from './pages/ResetPasswordPage.jsx';
import AcceptInvitePage from './pages/AcceptInvitePage.jsx';
import HandoffPage from './pages/HandoffPage.jsx';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/verify" element={<VerifyOtpPage />} />
      <Route path="/onboard" element={<OnboardingPage />} />
      <Route path="/logout" element={<LogoutPage />} />
      <Route path="/handoff" element={<HandoffPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      {/* The reset email links to AUTH_URL/reset-password/<token>; the older
          ?token= form still works for links already sent. */}
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      {/* The invitation email links to AUTH_URL/invite/<token>. */}
      <Route path="/invite/:token" element={<AcceptInvitePage />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
